var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQueryClient } from '@tanstack/react-query';
import { useAccountFeaturesQuery, useAccountSummaryV2Query as useAccountSummaryQuery, useCreditAccountsQuery } from 'syf-api';
import { useAllAccountSummaryQuery } from 'syf-api/allAccountSummary';
import { useConfig } from '../hooks/use-config';
import { useAuthorizedUsersGetQuery } from '../services/authorized-users/get/use-authorized-users-get-query';
import { useAuthorizedUsersPostMutation } from '../services/authorized-users/post/use-authorized-users-post-mutation';
import { useChangePaymentDueDateGetQuery } from '../services/change-payment-due-date';
import { useChangePaymentDueDatePutMutation } from '../services/change-payment-due-date/put/use-change-payment-due-date-put-mutation';
import { useAuthorizedBuyersLookupGetQuery } from '../services/authorized-buyers/use-authorized-buyer-get-lookup-query';
import getApiConfig from '../helpers/get-api-config';
var useCreditAccounts = function () {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var enabledQuery = Boolean(sessionStorage.getItem('accessToken'));
    var apiConfig = getApiConfig(queryClient, mfeConfig, enabledQuery);
    return useCreditAccountsQuery(__assign({ keyProps: undefined }, apiConfig));
};
var useAllAccountSummary = function (accounts) {
    var keyProps = accounts.map(function (account) {
        var _a;
        return {
            accountId: account.info['cipher.accountId'],
            accountIdType: (_a = account === null || account === void 0 ? void 0 : account.info) === null || _a === void 0 ? void 0 : _a.accountIdType
        };
    });
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accounts.length));
    return useAllAccountSummaryQuery(__assign({ keyProps: keyProps }, apiConfig));
};
var useAccountSummary = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAccountSummaryQuery(__assign({ keyProps: { accountId: accountId, accountIdType: 'guid' } }, apiConfig));
};
var useAccountFeatures = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAccountFeaturesQuery(__assign({ keyProps: { accountId: accountId, accountIdType: 'guid' } }, apiConfig));
};
var useAuthorizedUsersGet = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAuthorizedUsersGetQuery(__assign({ keyProps: { accountId: accountId, accountIdType: 'guid' } }, apiConfig));
};
var useMultiAuthorizedUsersPostMutation = function (config) {
    var queryClient = useQueryClient();
    var enabledMutation = Boolean(sessionStorage.getItem('accessToken'));
    var apiConfig = getApiConfig(queryClient, config, enabledMutation);
    return useAuthorizedUsersPostMutation(__assign({ keyProps: undefined }, apiConfig));
};
var useChangePaymentDueDateGet = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useChangePaymentDueDateGetQuery(__assign({ keyProps: { accountId: accountId, accountIdType: 'guid' } }, apiConfig));
};
var useChangePaymentDueDatePut = function (config) {
    var queryClient = useQueryClient();
    var enabledMutation = Boolean(sessionStorage.getItem('accessToken'));
    var apiConfig = getApiConfig(queryClient, config, enabledMutation);
    return useChangePaymentDueDatePutMutation(__assign({ keyProps: undefined }, apiConfig));
};
var useAuthorizedBuyersLookupGet = function (_a) {
    var lookupRequestData = _a.lookupRequestData, isEnabled = _a.isEnabled;
    var creditType = lookupRequestData.creditType, membershipNumber = lookupRequestData.membershipNumber, productType = lookupRequestData.productType;
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, isEnabled);
    var productTypeFormatted = productType === 'PRIVATE_LABEL' ? 'PLCC' : 'MASTERCARD';
    return useAuthorizedBuyersLookupGetQuery(__assign({ keyProps: {
            creditType: creditType,
            membershipNumber: membershipNumber,
            productType: productTypeFormatted
        } }, apiConfig));
};
export { useAccountFeatures, useAccountSummary, useAllAccountSummary, useAuthorizedBuyersLookupGet, useAuthorizedUsersGet, useChangePaymentDueDateGet, useChangePaymentDueDatePut, useCreditAccounts, useMultiAuthorizedUsersPostMutation };
